import { put } from 'redux-saga/effects';
import * as actions from '../actions/index';
import axios from 'axios';


export function* tryFetchPostsSaga(action) {
    try {
        const response = yield axios.get(process.env.REACT_APP_BLOG_LINK + 'posts', {
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': process.env.REACT_APP_BLOG_API_KEY,
            }
        });
        if (!response.status === 200) {
            yield put(actions.failFetchPosts());
        }
        const posts = response.data;
        let allPosts = posts.data;

        let lastPostId = posts.LastEvaluatedKey;
        let index = posts.data.length;
        while (lastPostId != null) {
            const nextPosts = yield axios.get(process.env.REACT_APP_BLOG_LINK + 'posts?LastEvaluatedKey=' + lastPostId, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.REACT_APP_BLOG_API_KEY,
                }
            });
            for (let i = 0; i < nextPosts.data.data.length; i++) {
                allPosts[index + i] = nextPosts.data.data[i]
            }
            index = index + nextPosts.data.data.length
            lastPostId = nextPosts.data.LastEvaluatedKey;
        }
        let finalAllPosts = []
        for (let i = 0; i < allPosts.length; i++) {
            if (allPosts[i].post.published) {
                finalAllPosts.push(allPosts[i])
            }
        }
        yield put(actions.successFetchPosts(finalAllPosts));
    } catch (error) {
        yield put(actions.failFetchPosts());
    }
}